import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DueTimeSpanPipe } from './due-time-span.pipe'
import { LogTimeSpanPipe } from './log-time-span.pipe'
import { HighlightTextPipe } from './highlight-text.pipe'

@NgModule({
  declarations: [DueTimeSpanPipe, LogTimeSpanPipe, HighlightTextPipe],
  imports: [CommonModule],
  exports: [DueTimeSpanPipe, LogTimeSpanPipe, HighlightTextPipe],
})
export class PipesModule {}
